export enum GACategories {
  languageSelector = "Language selector",
  navigation = "Navigation",
  help = "Help"
}
